import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { IS_NATIVE_APP } from "./config/api";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker: ativo SOMENTE em produção real.
// Desativado em: desenvolvimento (NODE_ENV !== 'production'), localhost, trycloudflare.com.
// Isso previne que o SW intercepte requisições HMR (hot-update.*) e cause reload em loop.

// Firebase Messaging usa um service worker dedicado para receber notificações
// mesmo com a Athena fechada. Além disso, a PWA verifica atualizações ao abrir:
// no Android um app instalado pode retomar um cliente antigo sem navegar de
// novo para index.html, mantendo o JavaScript da versão anterior.
if (!IS_NATIVE_APP && 'serviceWorker' in navigator) {
  const refreshInstalledApp = () => {
    if (sessionStorage.getItem('athena_sw_reloaded') === '1') return;
    sessionStorage.setItem('athena_sw_reloaded', '1');
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener('controllerchange', refreshInstalledApp);

  const checkBuildRevision = async () => {
    try {
      const response = await fetch('/athena-version.json', { cache: 'no-store' });
      if (!response.ok) return;
      const { revision } = await response.json();
      if (!revision) return;
      const key = 'athena_build_revision';
      const previous = localStorage.getItem(key);
      localStorage.setItem(key, revision);
      if (previous && previous !== revision) refreshInstalledApp();
    } catch {
      // A Athena continua disponível offline; apenas tenta novamente depois.
    }
  };

  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(async (registration) => {
      await registration.update();
      checkBuildRevision();
      window.addEventListener('focus', () => registration.update().catch(() => {}));
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          registration.update().catch(() => {});
          checkBuildRevision();
        }
      });
    })
    .catch(() => {});
}
